import React, { useCallback } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { Box, Typography } from 'housecall-ui';

import { Nullable, PricingFormFieldKind, PricingFormOptionType } from '../../types/types';

import { PricingFormMultiSelect } from './PricingFormMultiSelect';
import { PricingFormQuantity } from './PricingFormQuantity';
import { PricingFormRangeSelect } from './PricingFormRangeSelect';
import { PricingFormSingleSelect } from './PricingFormSingleSelect';

type Props = {
  kind: PricingFormFieldKind;
  name: string;
  id: number;
  options?: Nullable<PricingFormOptionType[]>;
};

const RenderForm = ({ kind, name, options, id }: Props) => {
  const formApi = useForm();
  const formState = useFormState();
  const value = formState.values[`id-${id}`];

  const onChange = useCallback(
    (newValue: number | boolean | Array<number>) => formApi.change(`id-${id}`, newValue),
    [formApi, id]
  );

  switch (kind) {
    case 'quantity_select':
      return <PricingFormQuantity value={Number.isNaN(value) ? 1 : value} onChange={onChange} />;
    case 'multiple_select':
      return <PricingFormMultiSelect value={value || []} onChange={onChange} options={options || []} />;
    case 'single_select':
      return <PricingFormSingleSelect onChange={onChange} value={value || ''} label={name} options={options || []} />;
    case 'numerical_range':
      return <PricingFormRangeSelect onChange={onChange} value={value || ''} label={name} options={options || []} />;
    default:
      return null;
  }
};

export const PricingFormField = (props: Props) => {
  return (
    <Box mb={2}>
      <Typography variant="subtitle1" gutterBottom data-testid="pricing-form-field">
        {props.name}
      </Typography>
      <RenderForm {...props} />
    </Box>
  );
};
